export enum EDividerMenuItem {
  SetThick,
  SetDashed,
  SetThin,
}

export enum EImageMenuItem {
  SetOriginalSize,
  SetHalfSize,
  SetFullSize,
  SetCoverSize,
  RemoveHeader,
  RemoveCaption,
  ToggleHeader,
  ToggleCaption,
  CloseHeadingMenu,
  CloseCaptionMenu,
  ShowLinkInput,
  CloseLinkInput,
  ReplaceImage,
}

export enum ETextMenuItem {
  ToggleBold,
  ToggleItalic,
  ToggleUnderline,
  ToggleOrderedList,
  ToggleBulletList,
  Undo,
  Redo,
  ShowLinkInput,
  CloseLinkInput,
}

export enum ETableMenuItem {
  ToggleBorder,
  ToggleHeaderRow,
  ToggleAlternateRowColor,
  DeleteColumn,
  DeleteRow,
  ToggleBold,
  ToggleItalic,
  ToggleUnderline,
  ToggleOrderedList,
  ToggleBulletList,
  Undo,
  Redo,
  ShowLinkInput,
  CloseLinkInput,
}
